// services/business-entity.service.ts
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { ExchangeRate, ExchangeRateSearchCommand } from '../../models/finance/exchange-rate';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class ExchangeRateProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/exchange-rate';

  public getByCurrency(currency: number): Observable<ApiResponse<ExchangeRate>> {
    return this.httpClient.get<ApiResponse<ExchangeRate>>(`${this.baseUrl}/current/${currency}`);
  }
  public searchExchangeRate(command: ExchangeRateSearchCommand): Observable<ApiResponse<ExchangeRate[]>> {
    return this.httpClient.post<ApiResponse<ExchangeRate[]>>(`${this.baseUrl}/search`, command);
  }
}
